var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKairausNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.58,2.36l-28.23,29.61v4.54l13.13-13.62L52,2.36h-4.42ZM28.4,36.26l-2.23,2.3,21.49,20.03,4.5.08-23.76-22.41ZM9.69,58.67h3.22V2.36h-3.22v56.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.44,2.36h-3.46s1.76,4.11,1.76,4.11h0s22.44,52.2,22.44,52.2h3.46L95.44,2.36ZM88.55,10.36l-20.78,48.31h3.54l19-44.2-1.76-4.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.74,58.67V2.36h3.22v56.31h-3.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M363.48,32.45h-19.9v-3.22h19.9v3.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.92,36.08v21.58h3.22v-21.58h-3.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M180.66,36.08h-4.83l14.89,21.62h4.83l-14.89-21.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.45,2.36v28.15c0,12.97-4.93,23.11-16.09,24.71v3.25c13.67-1.68,19.31-14.2,19.31-27.96V2.36h-3.22ZM276.83,30.52V2.36h-3.21v28.15c0,13.77,5.63,26.28,19.3,27.96v-3.24c-11.16-1.6-16.09-11.74-16.09-24.71Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M231.31,9.19l-20.84,48.47h3.54l19.07-44.36-1.77-4.11ZM238.14,1.36h-3.46l1.76,4.11h0s22.44,52.2,22.44,52.2h3.46L238.14,1.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M373.31,0v3.22h-7.2c-8.05,0-15.34,2.46-20.62,6.93-5.28,4.47-8.54,10.96-8.54,19.01h-3.19c0-8.05,3.27-15.34,8.54-20.62,5.28-5.28,12.56-8.54,20.62-8.54h10.39Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M333.76,60v-3.22h7.2c8.05,0,15.34-2.46,20.62-6.93,5.28-4.47,8.54-10.96,8.54-19.01h3.19c0,8.05-3.27,15.34-8.54,20.62s-12.56,8.54-20.62,8.54h-10.39Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M194.57,17.86c0,4.24-1.72,8.08-4.5,10.86-2.05,2.05-4.67,3.52-7.61,4.15h-22.54v-2.87h3.22s15.93,0,15.93,0c3.35,0,6.42-1.36,8.66-3.56,2.23-2.2,3.63-5.23,3.63-8.59,0-6.71-5.57-12.15-12.28-12.15h-19v-3.22h19.15c8.48,0,15.36,6.88,15.36,15.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKairausNew);
export default __webpack_public_path__ + "static/media/kairausNew.03f3be966f2cf9babab5c236103d2672.svg";
export { ForwardRef as ReactComponent };